/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit File/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ButtonIconLabel from 'DesignSystem/ButtonIconLabel/index'
import DocIcon from 'DesignSystem/Svgs/DocIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function File({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/Documents/Body/Content/Document/File"
  
}) {
let documentNameValueData = fromData.useDataValue({ viewPath,
context: 'document',
path: 'name',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonIconLabel
  viewPath={`${viewPath}/ButtonIconLabel`}
 marginTop={4}
 data="document.name"
 text={documentNameValueData}
 onClick={onClick}
>
{childProps => (
<DocIcon
{...childProps}
  viewPath={`${viewPath}/DocIcon`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIconLabel>
{children}
</React.Fragment>)
}